// extracted by mini-css-extract-plugin
export default {"categories__list":"categories_categories__list__s4nXi","item":"categories_item__YUrjh","active":"categories_active__m-7ZJ"};